<template>
  <div class="area">
    <div class="area-left">
      <van-picker
        title="标题"
        :columns="columns"
        @change="onChange"
        :default-index="defaultIndex"
      />
    </div>
    <div class="area-right">
      <div v-show="showArea">
        <van-area
          title="标题"
          :area-list="areaList"
          :columns-placeholder="['请选择', '请选择', '请选择']"
          :columns-num="2"
          :value="defaultArea"
          @change="bindChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data'
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  data() {
    return {
      areaList,
      columns: [
        { text: '国内', value: 1 },
        { text: '海外', value: 2 }
      ],
      areaData: [],
      showArea: true,
      defaultIndex: 0,
      defaultArea: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let value = this.data.value
      if (value !== '') {
        this.showArea = !!value
        /* 设置默认 */
        this.defaultIndex = this.data.value === 0 ? 1 : 0
        this.defaultArea = this.data.value + ''
      }
    },
    bindChange(picker, arr) {
      console.log(arr)
      this.areaData = arr
      let str = +arr[1].code || ''
      this.setAreaValue(str)
    },
    onChange(picker, item) {
      this.showArea = item.value == 1
      let value = item.value == 1 ? '' : 0
      this.setAreaValue(value)
    },
    /* 设置数据 */
    setAreaValue(value) {
      this.data.value = value
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.area {
  display: flex;
  align-items: center;

  ::v-deep .van-picker__toolbar {
    display: none;
  }

  .area-left {
    width: 80px;
  }

  .area-right {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
}
</style>
